import { ComponentLoader } from '@bythepixel/component-loader';
import InViewSrc from '@bythepixel/in-view-src';
import InViewSrcset from '@bythepixel/in-view-srcset';
import Accordion from '../components/accordion';
import PublishOn from '../components/publishOn';
import TabUnderline from '../components/tabUnderline';
import CartIcon from '../components/cartIcon';
import InViewAni from '../components/inViewAni';
import components from '../navigation';

setTimeout(() => {
  if (!window.location.hash.substring(1)) return;
  document.getElementById(window.location.hash.substring(1)).scrollIntoView();
}, 1000);

window.globalComponents = new ComponentLoader(document, [
  InViewSrc,
  InViewSrcset,
  TabUnderline,
  Accordion,
  PublishOn,
  CartIcon,
  InViewAni,
  ...components,
]);
